import React from "react";
import { useTranslation } from "react-i18next";
import "./page-not-found.scss";
import Footer from "../../components/footer/component";
import { Helmet } from "react-helmet";
import { ROUTE_CONSTANT } from "../../routing/route-constants";
import Logo from "../../components/header/navbar/logo";
import { useParams } from "react-router-dom";
import { currentDomain } from "../../utils/general-config";
import { DomainName } from "../../utils/constants";

const PageNotFound = () => {
  const { t } = useTranslation();
  // let locale = useParams();
  let locale = localStorage.getItem("i18nextLng");
  let pathRedirectHome =
    !!locale && locale != "en" ? ROUTE_CONSTANT.ROOT_HOME_LOCALE.replace(":locale", locale) : ROUTE_CONSTANT.ROOT_HOME;
  return (
    <>
      <div>
        <header className="header py-2.5">
          <div className="container px-4">
            <nav className="navbar navbar-expand-lg navbar-light">
              <div className="container">
                <Logo />
              </div>
            </nav>
          </div>
        </header>
        <Helmet>
          <meta name="description" content={t("page_not_found.heading")}/>
          <title>{t("page_title.page_not_found")}</title>
        </Helmet>
        <section className="section main-content text-center">
          <div id="wrapper" className="container page-not-found">
            <div className="not-found-img">
              <img src={process.env.PUBLIC_URL + "/static/images/not-found.svg"} />
            </div>
            <div id="info" className="not-found-content">
              <h1 className="my-2">{t("page_not_found.heading")}</h1>
              <p>{t("page_not_found.page_description")}</p>
              <div className="text-center d-block pb-5 mt-2">
                <a href={pathRedirectHome} className="btn btn-primary">
                  {t("page_not_found.btn_text")}
                </a>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
};

export default PageNotFound;
